import styled from 'styled-components';
import primitives from '@veneer/primitives';
import { Dot } from '@jarvis/react-portal-addons';

export const CustomDot = styled(Dot)`
  width: 16px;
  height: 16px;
  border: 1px solid ${primitives.color.gray6};
`;

export default CustomDot;
